@if (visionCount > 0) {
<av-tooltip
  [class.hidden]="isHidden()"
  position="bottom"
  message="Frame analyzed"
>
  <button
    [attr.aria-label]="'Frame analyzed' | translate"
    data-tid="tile-info/vision-count"
    avButton
    [disabled]="isWhisper"
    (click)="toggleAssistant()"
    color="primary"
    size="xxs"
    ofType="icon"
  >
    <av-icon class="tile-icon" mode="light" name="prompt"></av-icon>
  </button>
</av-tooltip>
} @if (!isScreen && snapshotCount > 0) {
<av-tooltip [class.hidden]="isHidden()" position="bottom">
  <button
    avButton
    color="primary"
    size="xxs"
    ofType="icon"
    (click)="snapshotRequest()"
    class="tile-info"
    [class.tile-info-action]="!isWhisper"
    [attr.aria-label]="
      ('Number of snapshots taken is ' | translate) + snapshotCount
    "
    data-tid="tile-info/snapshot-count"
  >
    <av-icon class="tile-icon" mode="light" name="camera"></av-icon>
  </button>
  @if (snapshotCount === 1) {
  <ng-container tooltipMessage>
    {{ "snapshot taken" | translate }}
  </ng-container>
  } @if (snapshotCount > 1) {
  <ng-container tooltipMessage>
    {{ "snapshots taken" | translate }}
  </ng-container>
  }
</av-tooltip>
} @if (isPinned()) {
<av-tooltip
  [class.hidden]="isHidden()"
  position="bottom"
  message="Participant is pinned"
>
  <button
    avButton
    color="primary"
    size="xxs"
    ofType="icon"
    (click)="unpin()"
    class="tile-info"
    [class.tile-info-action]="!isWhisper"
    [attr.aria-label]="'Participant is pinned' | translate"
    data-tid="tile-info/pinned"
  >
    <av-icon class="tile-icon" mode="light" name="pin"></av-icon>
  </button>
</av-tooltip>

} @if (isGroupOneAvailable()) {
<div class="tile-info-group">
  @if (isDebugRtc) {
  <div class="tile-info">
    <av-tooltip position="bottom">
      rtc
      <div class="debug" tooltipMessage>
        <div>id: {{ stream.id }}</div>
        <div>username: {{ stream.originator.username }}</div>
        <div>my username: {{ myself.username }}</div>
        <div>endpoint: {{ stream.originator.endpoint }}</div>
        @if (!!stream.mediaStream) {
        <div>media stream: {{ stream.mediaStream.id }}</div>
        }
        <div>local: {{ isLocal }}</div>
        <div>type: {{ stream.type }}</div>
        <!-- <div>cam off: {{isMutedStream(stream, kindVideo)}}</div> -->
        <!-- <div>mic off: {{isMutedStream(stream, kindAudio)}}</div> -->
        <div>
          tag muted: {{ stream.originator.endpoint === myself.endpoint }}
        </div>
      </div>
    </av-tooltip>
  </div>
  } @if (!isScreen) { @if (isRoleAgentVisible) {
  <div
    [attr.aria-label]="'Participant is agent' | translate"
    class="tile-info"
    [class.hidden]="isHidden()"
    data-tid="tile-info/role-agent"
  >
    <av-tooltip position="bottom" message="AGENT">
      @if (!isAIAssistant) {
      <av-icon class="tile-icon" mode="light" name="headset"></av-icon>
      } @if (isAIAssistant) {
      <av-icon class="tile-icon" mode="light" name="assistant"></av-icon>
      }
    </av-tooltip>
  </div>
  } @if (isNetworkIndicatorVisible) {
  <div class="tile-info" [class.hidden]="isHidden()">
    <app-network-indicator
      [endpoint]="stream.originator.endpoint"
    ></app-network-indicator>
  </div>
  } @if (isMutedMicAria() && !isLocal) {
  <span
    role="alert"
    class="tile-alert"
    [attr.aria-label]="'Participant\'s microphone is muted' | translate"
  >
  </span>
  } @if (isMutedCam() && !isLocal) {
  <span
    role="alert"
    class="tile-alert"
    [attr.aria-label]="'Participant\'s camera is muted' | translate"
  >
  </span>
  } @if (isMutedMic()) {
  <div
    class="tile-info"
    [attr.aria-label]="'Participant\'s microphone is muted' | translate"
    data-tid="tile-info/mic-muted"
  >
    <av-icon class="tile-icon" mode="light" name="mic-mute"></av-icon>
  </div>
  } @if (isCaptionsOn()) {
  <div
    class="tile-info"
    [attr.aria-label]="'Participant has enabled closed captions' | translate"
    [class.hidden]="isHidden()"
    data-tid="tile-info/captions-on"
  >
    <av-icon class="tile-icon" mode="light" name="cc"></av-icon>
  </div>
  } @if (color() && isPointerActive()) {
  <div
    class="tile-info tile-info-colors"
    [class.tile-info-colors-local]="isLocal"
    [attr.aria-label]="'Participant\'s marker color' | translate"
    data-tid="tile-info/pointer-color"
  >
    <av-tooltip message="Participant's color" position="bottom">
      <app-point-color
        (click)="isLocal && isColorPickerOpen.set(!isColorPickerOpen())"
        [color]="color()"
      ></app-point-color>
    </av-tooltip>
    @if (isLocal && isColorPickerOpen()) {
    <av-card
      [popup]="true"
      [backdrop]="false"
      vAlign="bottom"
      hAlign="center"
      arrow="top"
    >
      <av-card-body size="sm">
        @for (c of colors(); track c) {
        <app-point-color
          [color]="c"
          (click)="changeColor(c)"
          [class.active]="c === color()"
          [class.disabled]="isColorDisabled(c) && c !== color()"
        ></app-point-color>
        }
      </av-card-body>
    </av-card>
    }
  </div>
  } @if (isParticipantLanguageEnabled) {
  <div
    [attr.aria-label]="
      ('Participant\'s language is ' | translate) + participantLanguage
    "
    class="tile-info tile-info-lang"
    [class.hidden]="isHidden()"
    data-tid="tile-info/user-language"
  >
    <av-tooltip position="bottom">
      {{ participantLanguage }}
      <ng-container tooltipMessage>
        {{ "Customer's language is" | translate }}
        {{ participantLanguage | translate }}
      </ng-container>
    </av-tooltip>
  </div>
  } } @if (isWarning()) {
  <div role="group" class="tile-info fx-row fx-gap-10">
    @if (isViewerDisabled) {
    <av-tooltip position="bottom">
      <div class="fx-row fx-align-center">
        <div class="warning">!</div>
        @if (!isTileTooSmall()) {
        <small
          class="warning-label tile-info-tiny-hidden tile-info-pointer-hidden"
          translate
          >Poor Connection</small
        >
        }
      </div>
      <ng-container tooltipMessage>
        <small [innerHTML]="'The video will resume automatically' | translate">
        </small>
      </ng-container>
    </av-tooltip>
    } @if (isEndpointSick() || isStreamSick() || isStreamFailed()) {
    <av-tooltip [wrap]="true" position="bottom">
      <div class="fx-row fx-align-center">
        @if (isStreamSick() || isEndpointSick()) {
        <div class="warning">!</div>
        } @if (isStreamFailed()) {
        <div class="warning error">!</div>
        } @if (!isTileTooSmall()) {
        <small
          class="warning-label tile-info-tiny-hidden tile-info-pointer-hidden"
          translate
          >Unstable network/device</small
        >
        }
      </div>
      <ng-container tooltipMessage>
        <small
          [innerHTML]="
            'The video quality will recover automatically' | translate
          "
        >
        </small>
      </ng-container>
    </av-tooltip>
    }
  </div>
  }
</div>
}
<!-- </ng-container> -->
